<template>
  <el-drawer
    :visible.sync="drawer"
    direction="rtl"
    :size="1100"
    :show-close="false"
    @closed="closed"
  >
    <div class="title" slot="title">
      <i class="title-close el-icon-close" @click="closed"></i>
      <span class="title-text">批量检查及修改触达节点</span>
    </div>
    <div class="node">
      <div class="node-data">
        <span>共</span><span class="node-active">{{tableData.length}}</span>条数据
      </div>
      <div class="node-table" ref="tableRef">
        <el-table
          ref="tableDataRef"
          v-loading="tableLoading"
          border
          :data="tableData"
          :header-cell-style="{
            background: '#fafafa',
            'text-align': 'left',
          }"
          :cell-style="{ 'text-align': 'left' }"
          :max-height="getTableHeight"
        >
          <template slot="empty">
            <div>
              <img src="@/assets/images/default/暂无任何数据.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column
            prop="nodeName"
            label="节点名称"
            min-width="160"
          ></el-table-column>
          <el-table-column label="触达类型">
            <template slot-scope="scope">
              <span v-if="scope.row.smsType == 0">短信</span>
              <span v-if="scope.row.smsType == 1">富信</span>
              <span v-if="scope.row.smsType == 2">卡片短信</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="targetNodeName"
            label="目标人群节点名称"
            min-width="200"
          >
            <template slot="header">
              <div>
                目标人群节点名称
                <el-tooltip class="item" effect="light" content="该节点的前节点为目标客户或目标筛选节点时，则为对应节点的名称；如前节点为等待节点时，则为等待的前节点名称；" placement="top-start">
                  <span class="question_icon">?</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="短信内容" width="312">
            <template slot-scope="scope">
              <span :class="[{'node-tip':!scope.row.content}]" v-if="scope.row.smsType == 0">{{
                scope.row.content?scope.row.content:'未填写'
              }}</span>
              <span
                :class="[{'node-tip':!scope.row.templateName},'node-rich']"
                v-else-if="scope.row.smsType == 1 || scope.row.smsType == 2"
                @click="showContent(scope.row)"
                >{{ scope.row.templateName?scope.row.templateName:'未填写' }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="是否过滤黑名单" min-width="200">
            <template slot-scope="scope">
              <span>{{
                scope.row.filtrationBlacklistFlag == 1 ? "是" : "否"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="屏蔽近XX天已发送客户" min-width="200">
            <template slot-scope="scope">
              <span v-if="scope.row.filterDays"
                >{{ scope.row.filterDays }}天</span
              >
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="sendNum" label="发送人数" min-width="120">
            <template slot="header">
              <div>
                发送人数
                <el-tooltip class="item" effect="light" content="填写则为限制该节点的发送人数" placement="top-start">
                  <span class="question_icon">?</span>
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.sendNum">{{ scope.row.sendNum }}</span>
              <span v-else>不限</span>
            </template>
          </el-table-column>
          <el-table-column prop="mediaTestMobiles" label="短信测试" min-width="200">
          </el-table-column>
          <el-table-column label="操作" min-width="200" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" class="text-btn" @click="handleShowSendTip(scope.row)">发送短信测试</el-button>
              <el-button type="text" class="text-btn" @click="edit(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 富信模板 -->
    <sms-info
      v-if="smsInfoShow"
      @close="smsInfoShow = false"
      :isShow="smsInfoShow"
      :id="smsInfoId"
      :title="smsInfoTitle"
      :text="smsInfoText"
      :isDrawer="true"
    />
    <!-- 卡片 -->
    <sms-info-card
      v-if="smsInfoCardShow"
      :isShow="smsInfoCardShow"
      @close="smsInfoCardShow = false"
      :id="cardId"
      :isDrawer="true"
    ></sms-info-card>
    <!-- 发送确认弹窗 -->
    <send-confirm-dialog 
      :showSendConfirm.sync="showSendConfirm"
      :sendInfoLength="sendInfoLength"
      :phoneLenght="phoneLenght"
      :TTip="TTip"
      :isCustom="true"
      v-if="showSendConfirm"
      @comfirm="test"
    >
    </send-confirm-dialog>
    <!-- 富信 -->
    <sendTestMediaConfirm 
      v-if="sendTestMediaConfirmShow"
      @close="sendTestMediaConfirmShow = false" 
      @confirm="sendTestMediaConfirmShow = false"
      :source="3"
      :mediaTitle="rowData.mediaTitle"
      :totalSize="rowData.totalSize"
      :isCustom="true"
      :mediaTestMobilesList="rowData.mediaTestMobiles.split(',')"
      :mediaTemplateId="rowData.mediaTemplateId">
    </sendTestMediaConfirm>
    <!-- 卡片 -->
    <sendTestCardConfirm 
      v-if="sendTestCartMediaConfirmShow"
      @close="sendTestCartMediaConfirmShow = false" 
      @confirm="sendTestCartMediaConfirmShow = false"
      :source="3"
      :mediaTestMobilesList="rowData.mediaTestMobiles.split(',')"
      :title="rowData.mediaTitle"
      :mediaTemplateId="rowData.mediaTemplateId">
    </sendTestCardConfirm>
  </el-drawer>
</template>

<script>
import { getReachNodeList } from "@/api/intelligentMarket/index.js";
import smsInfo from "@/components/sms-info";
import smsInfoCard from "@/components/sms-info-card";
import sendConfirmDialog from './sendConfirmDialog';
import sendTestMediaConfirm from '@/components/sendTestMediaConfirm';
import sendTestCardConfirm from '@/components/sendTestCardConfirm';

import {
  testMedia,
  NewPreCommit,
} from "@/api/smsSend";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    marketingId: {
      type: Number
    }
  },
  components: {
    smsInfo,
    smsInfoCard,
    sendConfirmDialog,
    sendTestMediaConfirm,
    sendTestCardConfirm
  },
  data() {
    return {
      drawer: false,
      tableLoading: false,
      tableData: [],
      smsInfoShow: false,
      smsInfoId: "", // 富信id
      smsInfoTitle: "", // 富信标题
      smsInfoText: "", // 富信内容
      cardId: null,
      smsInfoCardShow: false,
      tableHeight: null,
      showSendConfirm: false,
      mobiles: "",
      TTip: "拒收请回复R",
      phoneLenght:0,
      rowData:{},
      sendTestMediaConfirmShow:false,
      sendTestCartMediaConfirmShow:false
    };
  },
  computed: {
    getTableHeight() {
      return this.tableHeight ? `${this.tableHeight}px` : "0px";
    },
    sendInfoLength() {
      return this.rowData.content.length
    }
  },
  watch: {
    value: {
      handler: function (val) {
        this.drawer = val;
      },
      immediate: true,
    },
  },
  created() {
    this.getList();
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = this.$refs.tableRef.offsetHeight;
    });
  },
  methods: {
    doLayouts() {
      var that = this;
      this.$nextTick(() => {
        that.$refs.tableDataRef.doLayout();
        var tableBox = that.$refs.tableDataRef.$vnode.elm;
        var tbody = tableBox.getElementsByTagName("tbody");
        var tableTbody = tbody[0];
        var fixedTbody = tbody[1];
        var tableTrs = tableTbody.getElementsByTagName("tr");
        var fixedTrs = fixedTbody.getElementsByTagName("tr");

        for (var i = 0; i < tableTrs.length; i++) {
          fixedTrs[i].style.height = tableTrs[i].offsetHeight + "px";
        }
      });
    },
    getList() {
      getReachNodeList({marketingId:this.marketingId}).then((res) => {
        this.tableData = res.data;
        this.doLayouts()
      });
    },
    showContent(row) {
      if(!row.templateName)return;
      if (row.smsType == 1) {
        this.showMediaInfo(row);
      } else if (row.smsType == 2) {
        this.showCardInfo(row);
      }
    },
    showMediaInfo(row) {
      this.smsInfoShow = true;
      this.smsInfoId = row.contentId;
      this.smsInfoTitle = row.mediaTitle;
      this.smsInfoText = row.content;
    },
    showCardInfo(row) {
      this.cardId = row.contentId;
      this.smsInfoCardShow = true;
    },
    closed() {
      this.$emit("input", false);
    },
    edit(row) {
      this.$emit("edit",row);
    },
    async handleShowSendTip(row) {
      this.rowData = row
      if(!row.mediaTestMobiles){
        return this.$message.warning("手机号不能为空")
      }
      if(row.smsType == 0){
        let content = row.content;
        const index = row.content.indexOf("】")
        if(row.content && index != -1){
          content = row.content.slice(index + 1)
        }
        // 敏感词检测
        const checkResult = await this.$wordCheck({ content })
        if (checkResult.code != 1) {
          return this.$message.error(checkResult.message)
        }
        this.showSendConfirm = true
        this.phoneLenght = row.mediaTestMobiles.split(',').length
      }else if(row.smsType == 1){
        this.sendTestMediaConfirmShow = true
      }else if(row.smsType == 2){
        this.sendTestCartMediaConfirmShow = true
      }
      
    },
    // 发送测试
    async test(){
      const row = this.rowData
      if(!row.mediaTestMobiles){
        return this.$message.warning("手机号不能为空")
      }
      if(row.smsType == 0){
        const postData = {
          mobile:row.mediaTestMobiles,
        }
        const index = row.content.indexOf("】")
        if(row.content && index != -1){
          postData.content = row.content.slice(index + 1)
        }
        NewPreCommit(postData).then((res) => {
        if (res.code == "1") {
          this.$message.success(res.data)
          this.showSendConfirm = false
        } else{
          this.$message.error(res.message);
        }
      })
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.title {
  padding-left: 4px;
  display: flex;
  align-items: center;
  &-close {
    font-size: 20px;
    margin-right: 12px;
    cursor: pointer;
  }
  &-text {
    color: #000000;
    font-size: 16px;
  }
}
.node {
  display: flex;
  flex-direction: column;
  height: 100%;
  &-data {
    padding: 0px 0px 12px 24px;
  }
  &-table {
    padding: 0px 24px;
    height: calc(100% - 57px);
  }
  &-btn {
    margin-left: 12px;
  }
  &-active {
    color: #2768ff;
  }
  &-content {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  &-tip {
    color: red!important;
    cursor: default !important;
  }
  &-rich {
    color: #2768ff;
    cursor: pointer;
  }
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #ccc;
  display: inline-block;
  line-height: 12px;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #ccc;
  font-size: 12px;
  font-weight: normal;
}
.text-btn{
  width: auto;
  padding: 0px!important;
}
/deep/ .el-drawer__header {
  border-bottom: 1px solid #eee;
  padding-bottom: 16px;
  margin-bottom: 24px;
}
/deep/ .el-table .el-table__header-wrapper th .cell {
  line-height: 48px;
}
/deep/ .el-table .cell {
  line-height: 40px!important;
}
/deep/ .el-table__empty-text{
  text-align: left;
}
</style>